import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FeaturesListing from "@components/FeaturesListing/FeaturesListing";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Meta from "@components/Meta/Meta";
import { remAccents } from "@helpers/utils.js";

const ROOT = process.env.REACT_APP_CMS_STATIC;

function CreditosPersonalesListado(props) {
  const [matches, setMatches] = useState([]);
  const [credsData, setCredsData] = useState([]);
  const [btnSoliciteCredito, setBtnSoliciteCredito] = useState("");

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { creditosPersonales } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter(
    (route) => route?.name === "Creditos Personales Listado"
  );

  const prevRoute = defRoute.map((route) => {
    return {
      url: route.url,
      text: route.h1,
    };
  });

  useEffect(() => {
    if (
      creditosPersonales &&
      creditosPersonales.aCBotonSoliciteSuCredito &&
      creditosPersonales.aCBotonSoliciteSuCredito[0]?.imagen
    ) {
      setBtnSoliciteCredito(
        creditosPersonales.aCBotonSoliciteSuCredito[0].imagen.urls[0]
      );
    }

    let promise = new Promise((resolve, reject) => {
      let personales = creditosPersonales?.aCCreditosPersonales;
      let normalizeCreds =
        personales &&
        personales?.map((cred) => ({
          ...cred,
          nombre: remAccents((cred?.titulo).split(" ").join("").toLowerCase()),
          rutaPrevia: prevRoute,
        }));

      resolve(normalizeCreds);
    });

    promise.then((resultado) => setMatches(resultado));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditosPersonales]);

  useEffect(() => {
    const curSection =
      rutas && rutas.filter((uri) => uri.name === "CreditosPersonales");
    const rootUri = curSection && curSection[0]?.url;

    let items =
      matches &&
      matches.map((cred) => {
        const credUri = cred?.rutaPrevia[0]?.url + "/" + cred?.idCredito;

        const botones = [
          {
            ruta: { url: credUri },
            imagen: { urls: [encodeURI("/CSCMS/media/Boton Mas Info.png")] },
          },
        ];
        cred?.urlFormularioSoliciteCredito &&
          cred?.urlFormularioSoliciteCredito.url &&
          btnSoliciteCredito &&
          botones.push({
            ruta: { url: cred?.urlFormularioSoliciteCredito.url },
            imagen: { urls: [btnSoliciteCredito] },
          });
        return {
          title: cred?.titulo,
          image: ROOT + cred?.imagen.urls[0],
          url: rootUri.replace("/:id", "/" + cred.idCredito),
          description: cred?.resumen?.html,
          buttons: botones,
        };
      });

    setCredsData(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, btnSoliciteCredito]);

  return (
    <div className="pt-5">
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      <h1 className="slogan">{defRoute[0].h1}</h1>
      <FeaturesListing features={credsData} />
    </div>
  );
}

export default CreditosPersonalesListado;
